import {Directive, ElementRef} from '@angular/core';

@Directive({
    selector: '[appTheoryBody]',
    standalone: false,
})
export class ContentTheoryBodyDirective {
    constructor(private elementRef: ElementRef) {
        console.log(elementRef);
    }
}
